<template>
  <b-card v-if="data_item.attributes"
      align="left"
      style="margin: 5px; padding: 10px;"
    >
    <h1 align="left" class="bg-secondary text-white">{{humanize(data_item.attributes['title'])}}</h1>
    <b-card-text>
      {{data_item.attributes['description']}}
    </b-card-text>
  </b-card>
</template>

<script>
export default {
  props: {
    data_item: {
      Type: Object
    },
    mappings: {
      Type: Array
    },
    included: {
      Type: Array
    }
  },
  methods: {
    humanize(str) {
      return str
          .replace(/^[\s_]+|[\s_]+$/g, '')
          .replace(/[_\s]+/g, ' ')
          .replace(/[-\s]+/g, ' ')
          .replace(/^[a-z]/, function(m) { return m.toUpperCase(); })
    }
  }
}
</script>

<style>
  h1 { font-size: 24px; }
</style>